import { render, staticRenderFns } from "./InstantUpdateHtmlTextArea.vue?vue&type=template&id=08cdfdf2"
import script from "./InstantUpdateHtmlTextArea.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateHtmlTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports